import React from "react";

import { toast } from "react-hot-toast";

import Content from "../../components/content/Content";
import ContentHead from "../../components/content/ContentHead";
import ContentBody from "../../components/content/ContentBody";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import InputField from "../../components/inputField/inputField";
import TextEditor from "../../components/textEditor/textEditor";
import withRouter from "../../components/withRouter/withRouter";
import ToggleSwitch from "../../components/toggleSwitch";
import {
  addUpdateApi,
  deleteByIdApi,
  getAllApi,
  getByIdApi,
  getCategoriesApi,
  uploadImageApi,
} from "../../api";
import he from "he";
import CategoryDropDown from "../../components/categoryDropDown/CategoryDropDown";
import { isValidURL } from "../../utils/isValidUrl";
// import { getFileName } from "../../Utils/getFileName";
// import langObj from "../../Utils/lang";

class AddUpdateTechnology extends React.Component {
  state = {
    imageUrl: "",
    imageObject: "",
    imageCaption: "",
    imageAlt: "",
    content: "", // body
    title: "",
    shortDescription: "", // description
    category: "",
    tagText: "",
    tags: [],
    adOneUrl: "",
    adTwoUrl: "",
    buttonOneUrl: "",
    buttonTwoUrl: "",
    loading: false,
    isImageChanged: false,
    author: "",
    showBtn: false,
    keyPoints: [],
    keyPointsHeading: "",
    qanda: [],
    qandaHeading: "",
    techName: "",
    why: [],
    whyHeading: "",
    whyImage: { url: "", obj: "" },
    whyImageCaption: "",
    whyImageAlt: "",
    whyShowButton: false,
    whyButtonText: "",
    whyButtonLink: "",
    fold1: [],
    techHeading: "",
    techLogo: { url: "", obj: "" },
    techLogoCaption: "",
    techLogoAlt: "",
    tailored: [],
    tailoredHeading: "",
    tailoredDescription: "",
    tailoredSecondHeading: "",
    tailoredBtnShow: "",
    tailoredBtnText: "",
    tailoredBtnUrl: "",
    buttonUrl: "",
    buttonText: "",
    metaTitle: "",
    metaDescription: "",
    metaCanonicalUrl: "",
    slug: "",
    caseStudies: [],
    selectedCaseStudy: "",
    categories: [],
  };

  componentDidMount() {
    this.getCategories();
    this.getCaseStudy();
    if (this.props.router.params.id) {
      this.setState({ loading: true });
      this.getData();
    }
  }

  getCategories = () => {
    getCategoriesApi()
      .then((res) => {
        console.log(res);
        const d = res.data.filter((val) => val.categoryType === "Technology");

        this.setState({ categories: d });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getCaseStudy = () => {
    getAllApi("caseStudy")
      .then((res) => {
        this.setState({ caseStudies: res.data });
        if (this.props.router.params.id) {
          this.getData();
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        this.setState({ caseStudies: [] });
        if (this.props.router.params.id) {
          this.getData();
        } else {
          this.setState({ loading: false });
        }
      });
  };

  getData = () => {
    getByIdApi("technology", this.props.router.params.id)
      .then((res) => {
        const temp = res.data;

        console.log(temp.tailoredSection);

        const toSet = {
          imageUrl: temp?.bannerImage || "",
          imageCaption: temp?.bannerImageCaption,
          imageAlt: temp?.bannerImageAlt,
          title: he.decode(temp?.title || ""),
          category: he.decode(temp?.category || ""),
          tags: temp?.tags || [],
          showBtn: temp?.buttonShow || false,
          buttonText: temp?.buttonText || "",
          buttonUrl: temp?.buttonLink || "",
          description: he.decode(temp?.description || ""),
          fold1:
            temp?.aboutTechonology?.details.map((val) => ({
              ...val,
              title: he.decode(val?.title || ""),
              description: he.decode(val?.description || ""),
            })) || [],
          techLogo: { url: temp?.aboutTechonology?.techLogo || "", obj: "" },
          techHeading: he.decode(temp?.aboutTechonology?.heading || ""),
          techLogoCaption: temp?.aboutTechonology?.techLogoCaption,
          techLogoAlt: temp?.aboutTechonology?.techLogoAlt,
          techName: temp?.aboutTechonology?.technologyName,
          why: temp?.whySection?.details.map((v) => ({
            ...v,
            icon: { url: v.icon || "", obj: "" },
            title: he.decode(v?.title || ""),
            description: he.decode(v?.description || ""),
          })),
          whyImageCaption: temp?.whySection?.imageCaption,
          whyImageAlt: temp?.whySection?.imageAlt,
          whyHeading: he.decode(temp?.whySection?.heading || ""),
          whyImage: { url: temp?.whySection?.image || "", obj: "" },
          whyShowButton: temp?.whySection?.showButton,
          whyButtonText: temp?.whySection?.buttonText,
          whyButtonLink: temp?.whySection?.buttonLink,
          keyPointsHeading: he.decode(temp?.keyPoints?.heading || ""),
          keyPoints: temp?.keyPoints?.details.map((v) => ({
            ...v,
            pointText: "",
            title: he.decode(v?.title || ""),
            description: he.decode(v?.description || ""),
          })),
          qandaHeading: he.decode(temp?.FAQ?.heading || ""),
          qanda: temp?.FAQ?.details.map((v) => ({
            ...v,
            question: he.decode(v?.question || ""),
            answer: he.decode(v?.answer || ""),
          })),
          tailored: temp?.tailoredSection?.steps?.map((val) => ({
            ...val,
            icon: { url: val?.icon, obj: "" },
            title: he.decode(val?.title),
            secondaryTitle: he.decode(val?.secondaryTitle),
            description: he.decode(val?.description),
          })),
          tailoredHeading: he.decode(temp?.tailoredSection?.heading || ""),
          tailoredDescription: he.decode(
            temp?.tailoredSection?.description || ""
          ),
          tailoredSecondHeading: he.decode(
            temp?.tailoredSection?.secondHeading || ""
          ),
          tailoredBtnShow: temp?.tailoredSection?.buttonShow || false,
          tailoredBtnText: temp?.tailoredSection?.buttonText,
          tailoredBtnUrl: temp?.tailoredSection?.buttonLink,
          slug: temp?.metaData?.slug,
          metaTitle: temp?.metaData?.metaTitle,
          metaDescription: temp?.metaData?.metaDescription,
          metaCanonicalUrl: temp?.metaData?.canonicalUrl,
          loading: false,
          // selectedCaseStudy: temp?.caseStudy,
          selectedCaseStudy: temp?.caseStudy?._id || "",
        };

        this.setState(toSet);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong while getting blog data.");
        this.props.router.navigate("/technology");
      });
  };

  handleImage = (event) => {
    this.setState({
      imageUrl: URL.createObjectURL(event.target.files[0]),
      imageObject: event.target.files[0],
      isImageChanged: true,
    });
  };

  handleWhyImage = (event) => {
    this.setState({
      whyImage: {
        url: URL.createObjectURL(event.target.files[0]),
        obj: event.target.files[0],
      },
    });
  };

  removeExtension(filename) {
    return filename.substring(0, filename.lastIndexOf(".")) || filename;
  }

  validate = () => {
    if (!this.state.imageUrl) {
      toast.error("Banner Image is required.");
      return false;
    }
    if (!this.state.imageCaption) {
      toast.error("Banner Image Caption is required.");
      return false;
    }
    if (!this.state.imageAlt) {
      toast.error("Banner Image Alt is required.");
      return false;
    }
    if (!this.state.title) {
      toast.error("Title is required.");
      return false;
    }
    if (!this.state.category) {
      toast.error("Category is required.");
      return false;
    }
    if (this.state.tags.length === 0) {
      toast.error("Keywords are required.");
      return false;
    }
    if (this.state.showBtn && !this.state.buttonText) {
      toast.error("Button Text is required.");
      return false;
    }
    if (this.state.showBtn && !this.state.buttonUrl) {
      toast.error("Button Url is required.");
      return false;
    }
    if (this.state.showBtn && !isValidURL(this.state.buttonUrl)) {
      toast.error("Please enter a valid button url.");
      return false;
    }
    if (!this.state.description) {
      toast.error("Description is required.");
      return false;
    }
    if (this.state.fold1.length === 0) {
      toast.error("About Technology is required.");
      return false;
    }
    if (!this.state.techHeading) {
      toast.error("About technology section's heading is required.");
      return false;
    }
    if (!this.state.techName) {
      toast.error("Technology Name is required.");
      return false;
    }
    if (!this.state.techLogo.url) {
      toast.error("Tech Logo is required.");
      return false;
    }
    if (!this.state.techLogoCaption) {
      toast.error("About Technology's Image Caption is required.");
      return false;
    }
    if (!this.state.techLogoAlt) {
      toast.error("About Technology's Image Alt is required.");
      return false;
    }
    for (let i = 0; i < this.state.fold1.length; i++) {
      const val = this.state.fold1[i];
      if (!val.title) {
        toast.error("About Technology's list title is required.");
        return false;
      }
      if (!val.description) {
        toast.error("About Technology's description is required.");
        return false;
      }
    }
    if (this.state.caseStudies.length !== 0 && !this.state.selectedCaseStudy) {
      toast.error("Case Study is required.");
      return false;
    }
    if (this.state.why.length === 0) {
      toast.error("Why section is required.");
      return false;
    }
    if (!this.state.whyHeading) {
      toast.error("Why Section's heading is required.");
      return false;
    }
    if (!this.state.whyImage.url) {
      toast.error("Why Section's Image is required.");
      return false;
    }
    if (!this.state.whyImageCaption) {
      toast.error("Why Section's Image Caption is required.");
      return false;
    }
    if (!this.state.whyImageAlt) {
      toast.error("Why Section's Image Alt is required.");
      return false;
    }

    for (let i = 0; i < this.state.why.length; i++) {
      const v = this.state.why[i];
      if (!v.icon.url) {
        toast.error("Why Section's icon is required.");
        return false;
      }
      if (!v.iconCaption) {
        toast.error("Why Section's icon caption is required.");
        return false;
      }
      if (!v.iconAlt) {
        toast.error("Why Section's icon alt is required.");
        return false;
      }
      if (!v.title) {
        toast.error("Why Section's list title is required.");
        return false;
      }
      if (!v.description) {
        toast.error("Why Section's list description is required.");
        return false;
      }
    }

    if (this.state.keyPoints.length === 0) {
      toast.error("Key Points are required.");
      return false;
    }
    if (!this.state.keyPointsHeading) {
      toast.error("Key Point's heading is required.");
      return false;
    }
    for (let i = 0; i < this.state.keyPoints.length; i++) {
      const v = this.state.keyPoints[i];
      if (!v.title) {
        toast.error("Key Point's list title is required.");
        return false;
      }
      if (!v.description) {
        toast.error("Key Point's list points are required.");
        return false;
      }
    }

    // tailored
    if (this.state.tailored.length === 0) {
      toast.error("Tailored Section is required.");
      return false;
    }

    if (!this.state.tailoredHeading) {
      toast.error("Tailored Section's heading is required.");
      return false;
    }

    if (!this.state.tailoredDescription) {
      toast.error("Tailored Section's description is required.");
      return false;
    }

    if (!this.state.tailoredSecondHeading) {
      toast.error("Tailored Section's second heading is required.");
      return false;
    }

    if (this.state.tailoredBtnShow && !this.state.tailoredBtnText) {
      toast.error("Tailored Section's Button Text is required.");
      return false;
    }

    if (this.state.tailoredBtnShow && !this.state.tailoredBtnUrl) {
      toast.error("Tailored Section's Button Url is required.");
      return false;
    }

    if (this.state.tailoredBtnShow && !isValidURL(this.state.tailoredBtnUrl)) {
      toast.error("Please enter valid button url in tailored section. ");
      return false;
    }

    for (let i = 0; i < this.state.tailored.length; i++) {
      const v = this.state.tailored[i];
      if (!v.icon.url) {
        toast.error("Tailored section's list icon is required.");
        return false;
      }
      if (!v.iconCaption) {
        toast.error("Tailored section's list icon caption is required.");
        return false;
      }
      if (!v.iconAlt) {
        toast.error("Tailored section's list icon alt is required.");
        return false;
      }
      if (!v.title) {
        toast.error("Tailored section's list title is required.");
        return false;
      }
      if (!v.secondaryTitle) {
        toast.error("Tailored section's list secondary title is required.");
        return false;
      }
      if (!v.description) {
        toast.error("Tailored section's list description is required.");
        return false;
      }
    }

    if (this.state.qanda.length === 0) {
      toast.error("F&Q is required.");
      return false;
    }
    if (!this.state.qandaHeading) {
      toast.error("F&Q's heading is required.");
      return false;
    }
    for (let i = 0; i < this.state.qanda.length; i++) {
      const v = this.state.qanda[i];
      if (!v.question) {
        toast.error("F&Q's question is required.");
        return false;
      }
      if (!v.answer) {
        toast.error("F&Q's answer is required.");
        return false;
      }
    }

    if (!this.state.slug) {
      toast.error("Slug is required.");
      return false;
    }
    if (!this.state.metaTitle) {
      toast.error("Meta Title is required.");
      return false;
    }
    if (!this.state.metaDescription) {
      toast.error("Meta Description is required.");
      return false;
    }
    if (!this.state.metaCanonicalUrl) {
      toast.error("Canonical Url is required.");
      return false;
    }
    if (!isValidURL(this.state.metaCanonicalUrl)) {
      toast.error("Please enter valid canonical url.");
      return false;
    }
    return true;
  };

  uploadImage = async () => {
    if (this.state.imageObject) {
      try {
        const response = await uploadImageApi(
          this.state.imageObject,
          "technology"
        );

        return response.data.imageUrl;
      } catch (error) {
        console.log(error);
        throw error;
      }
    }
    return this.state.imageUrl;
  };

  getTechnologyData = async () => {
    const techData = {
      heading: this.state.techHeading,
      technologyName: this.state.techName,
      techLogoCaption: this.state.techLogoCaption,
      techLogoAlt: this.state.techLogoAlt,
      details: [],
    };

    if (this.state.techLogo.obj) {
      const r = await uploadImageApi(this.state.techLogo.obj, "technology");
      techData.techLogo = r.data.imageUrl;
    } else {
      techData.techLogo = this.state.techLogo.url;
    }

    techData.techLogoCaption = this.state.techLogoCaption;
    techData.techLogoAlt = this.state.techLogoAlt;

    techData.details = this.state.fold1;

    console.log(techData);

    return techData;
  };

  getWhyData = async () => {
    const whyData = {
      heading: this.state.whyHeading,
      imageCaption: this.state.whyImageCaption,
      imageAlt: this.state.whyImageAlt,
      showButton: this.state.whyShowButton,
      buttonText: this.state.whyButtonText,
      buttonLink: this.state.whyButtonLink,
      details: [],
    };

    console.log(this.state.whyImage);

    if (this.state.whyImage.obj) {
      const r = await uploadImageApi(this.state.whyImage.obj, "technology");
      whyData.image = r.data.imageUrl;
    } else {
      whyData.image = this.state.techLogo.url;
    }

    for (let i = 0; i < this.state.why.length; i++) {
      if (this.state.why[i].icon.obj) {
        const ii = await uploadImageApi(
          this.state.why[i].icon.obj,
          "technology"
        );

        whyData.details.push({
          icon: ii.data.imageUrl,
          title: this.state.why[i].title,
          description: this.state.why[i].description,
          iconCaption: this.state.why[i].iconCaption,
          iconAlt: this.state.why[i].iconAlt,
        });
      } else {
        whyData.details.push({
          icon: this.state.why[i].icon.url,
          title: this.state.why[i].title,
          description: this.state.why[i].description,
          iconCaption: this.state.why[i].iconCaption,
          iconAlt: this.state.why[i].iconAlt,
        });
      }
    }

    console.log(whyData);

    return whyData;
  };

  getKeyPointsData = async () => {
    const keyData = {};

    keyData.heading = this.state.keyPointsHeading;

    keyData.details = this.state.keyPoints.map((val) => ({
      title: val.title,
      description: val.description,
      points: val.points,
    }));

    console.log(keyData);

    return keyData;
  };

  getTailoredData = async () => {
    const tailoredData = { steps: [] };

    tailoredData.heading = this.state.tailoredHeading;
    tailoredData.description = this.state.tailoredDescription;
    tailoredData.secondHeading = this.state.tailoredSecondHeading;
    tailoredData.buttonText = this.state.tailoredBtnText;
    tailoredData.buttonLink = this.state.tailoredBtnUrl;
    tailoredData.buttonShow = this.state.tailoredBtnShow;

    const arr = this.state.tailored;

    try {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].icon.obj) {
          try {
            const res = await uploadImageApi(arr[i].icon.obj, "technology");

            console.log(res);

            tailoredData.steps.push({
              ...arr[i],
              icon: res.data.imageUrl,
            });
          } catch (err) {
            tailoredData.steps.push({
              ...arr[i],
              icon: "",
            });
          }
        } else {
          tailoredData.steps.push({
            ...arr[i],
            icon: arr[i].icon.url,
          });
        }
      }
    } catch (err) {
      console.log(err);
    }

    console.log(tailoredData);

    return tailoredData;
  };

  getFandQData = async () => {
    const fandqData = { values: [] };

    fandqData.heading = this.state.qandaHeading;

    fandqData.details = this.state.qanda.map((v) => ({
      question: v.question,
      answer: v.answer,
    }));

    console.log(fandqData);

    return fandqData;
  };

  handleSubmit = (event) => {
    if (event.target.name === "btn3") {
      this.props.router.navigate("/technology");
    } else {
      if (this.validate()) {
        this.setState({ loading: true });
        this.uploadImage()
          .then(async (res) => {
            console.log(res);
            let techData = await this.getTechnologyData();
            console.log(techData);
            let whyData = await this.getWhyData();
            console.log(whyData);
            let keyPointsData = await this.getKeyPointsData();
            console.log(keyPointsData);
            let tailoredData = await this.getTailoredData();
            console.log(tailoredData);
            let fandqData = await this.getFandQData();
            console.log(fandqData);

            addUpdateApi({
              data: {
                bannerImage: res,
                bannerImageCaption: this.state.imageCaption,
                bannerImageAlt: this.state.imageAlt,
                title: this.state.title,
                category: this.state.category,
                tags: this.state.tags,
                buttonText: this.state.buttonText,
                buttonLink: this.state.buttonUrl,
                buttonShow: this.state.showBtn,
                description: this.state.description,
                aboutTechonology: techData,
                whySection: whyData,
                tailoredSection: tailoredData,
                keyPoints: keyPointsData,
                FAQ: fandqData,
                metaData: {
                  slug: this.state.slug,
                  metaTitle: this.state.metaTitle,
                  metaDescription: this.state.metaDescription,
                  canonicalUrl: this.state.metaCanonicalUrl,
                },
                // caseStudy: this.state.selectedCaseStudy,
                caseStudy: this.state?.selectedCaseStudy || null,
              },
              type: "technology",
              method: this.props.router.params.id ? "patch" : "post",
              id: this.props.router.params.id,
            })
              .then((res) => {
                toast.success("Technology created successfully.");
                this.props.router.navigate("/technology");
              })
              .catch((ee) => {
                toast.error(ee.response.data.message);
                this.setState({ loading: false });
              });
          })
          .catch((err) => {
            this.setState({ loading: false });

            toast.error(err.response.data.message);
          });
      }
    }
  };

  deleteCategory = (id) => {
    this.setState({ loading: true });
    deleteByIdApi("category", id)
      .then(() => {
        toast.success("Category deleted successfully.");
        getCategoriesApi()
          .then((res) => {
            const d = res.data.filter(
              (val) => val.categoryType === "Technology"
            );

            this.setState({ categories: d, loading: false });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        toast.error("Something went wrong while deleting category.");
      });
  };

  render() {
    return (
      <>
        {this.state.loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(0,0,0,.3)",
              zIndex: 100000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="loader"></span>
          </div>
        )}
        <Content>
          <ContentHead
            title={
              this.props?.title ? "Update Technology" : "Add New Technology"
            }
            showBtn1={true}
            showBtn2={false}
            showBtn3={true}
            btn1type="filled"
            btn2type="outlined"
            btn3type="outlined_del"
            btn1Name="btn1"
            btn2Name="btn2"
            btn3Name="btn3"
            btn1Text={"Save"}
            btn2Text={"Save As Draft"}
            btn3Text={"Cancel"}
            onClickHandler={this.handleSubmit}
          />
          <ContentBody>
            <div className="grid">
              <div className="card grid">
                <h3>Hero</h3>
                <div>
                  <p
                    style={{
                      fontSize: ".9",
                      transform: "translateX(5px)",
                      marginTop: "10px",
                    }}
                  >
                    Banner Image
                    <span
                      style={{ color: "#a3a3a3", fontSize: ".8rem" }}
                    ></span>
                    {this.state.imageUrl && (
                      <span
                        style={{
                          display: "inline-flex",
                          borderRadius: "10px",
                          marginLeft: "10px",
                          color: "#CB1829",
                          cursor: "pointer",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          this.setState({ imageUrl: "", imageObject: "" });
                        }}
                        title="Delete image"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </span>
                    )}
                  </p>

                  {!this.state.imageUrl ? (
                    <div
                      style={{
                        height: "50px",
                        width: "50px",
                        textAlign: "center",
                        background: "transparent",
                        border: "1px dashed grey",
                        borderRadius: "10px",
                        margin: "10px",
                        cursor: "pointer",
                        position: "relative",
                        marginBottom: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      +
                      <input
                        type="file"
                        style={{
                          opacity: 0,
                          position: "absolute",
                          top: 0,
                          bottom: 0,
                          right: 0,
                          left: 0,
                          cursor: "pointer",
                        }}
                        accept="image/*"
                        onChange={this.handleImage}
                      ></input>
                    </div>
                  ) : (
                    <div style={{ width: "45%", marginBottom: "40px" }}>
                      <div
                        style={{
                          width: "100%",
                          aspectRatio: "16/9",
                          backgroundImage: `url('${
                            this.props.router.params.id
                              ? this.state.isImageChanged
                                ? this.state.imageUrl
                                : this.state.imageUrl
                              : this.state.imageUrl
                          }')`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          marginTop: "10px",
                          borderRadius: "15px",
                          position: "relative",
                        }}
                      ></div>
                      {this.state.imageObject && (
                        <p style={{ textAlign: "center" }}>
                          {this.state.imageObject.name}
                        </p>
                      )}
                    </div>
                  )}

                  {this.state.imageUrl && (
                    <div className="grid_2">
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Image Caption"}
                        value={this.state.imageCaption}
                        onChange={(e) => {
                          this.setState({ imageCaption: e.target.value });
                        }}
                      />
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Image Alt"}
                        value={this.state.imageAlt}
                        onChange={(e) =>
                          this.setState({ imageAlt: e.target.value })
                        }
                      />
                    </div>
                  )}

                  <InputField
                    type="text"
                    value={this.state.title}
                    onChange={(e) => this.setState({ title: e.target.value })}
                    isLabel={true}
                    lable="Title"
                    showCharLength={true}
                    limitChar={40}
                  />
                </div>

                <div className="grid_2">
                  <CategoryDropDown
                    categories={this.state.categories}
                    value={this.state.category}
                    placeholder="Select/Add Category"
                    onChange={(v) => this.setState({ category: v })}
                    deleteCategory={this.deleteCategory}
                  />
                  <div>
                    <InputField
                      type="text"
                      isLabel={true}
                      value={this.state.tagText}
                      lable={"Keywords (Press Enter to add)"}
                      isRequired={false}
                      placeholder={"Comma separated values"}
                      onChange={(e) => {
                        this.setState({ tagText: e.target.value });
                      }}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          this.setState({
                            tags: [...this.state.tags, this.state.tagText],
                            tagText: "",
                          });
                        }
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        marginTop: "10px",
                      }}
                    >
                      {this.state.tags.map((tag, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              background: "var(--blue-light)",
                              color: "var(--blue-dark)",
                              padding: "5px 10px",
                              borderRadius: "5px",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            {tag}
                            <FontAwesomeIcon
                              icon={faClose}
                              style={{
                                color: "var(--blue-dark)",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                let temp = [...this.state.tags];
                                temp.splice(index, 1);
                                this.setState({ tags: temp });
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div
                    style={{
                      height: "50px",
                      width: "100%",
                      border: "1px solid lightgrey",
                      background: "white",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      paddingInline: "15px",
                      justifyContent: "space-between",
                      marginTop: "25px",
                    }}
                  >
                    <p>Show Button</p>
                    <ToggleSwitch
                      value={this.state.showBtn}
                      onClick={() =>
                        this.setState({ showBtn: !this.state.showBtn })
                      }
                    />
                  </div>
                  {this.state.showBtn && (
                    <>
                      <InputField
                        type="text"
                        isLabel={true}
                        value={this.state.buttonText}
                        lable="Button Text"
                        placeholder="Enter button text"
                        onChange={(e) => {
                          this.setState({ buttonText: e.target.value });
                        }}
                      />
                      <InputField
                        type="text"
                        isLabel={true}
                        value={this.state.buttonUrl}
                        lable="Button Link"
                        placeholder="Enter button Link"
                        onChange={(e) => {
                          this.setState({ buttonUrl: e.target.value });
                        }}
                      />
                    </>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <p style={{ paddingLeft: "5px" }}>Description</p>
                  <TextEditor
                    handleChange={(val) => {
                      this.setState({ description: val });
                    }}
                    content={this.state.description}
                  />
                </div>
              </div>

              <div className="card grid">
                <h3>
                  About Technology
                  <button
                    onClick={() => {
                      let temp = [...this.state.fold1];
                      temp.push({
                        title: "",
                        description: "",
                      });
                      this.setState({ fold1: temp });
                    }}
                  >
                    Add
                  </button>
                </h3>
                {this.state.fold1?.length !== 0 && (
                  <div className="grid">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <p style={{ paddingLeft: "5px" }}>Heading</p>
                      <TextEditor
                        handleChange={(val) => {
                          this.setState({ techHeading: val });
                        }}
                        content={this.state.techHeading}
                        smallEditor={true}
                      />
                    </div>
                    <div className="grid_2">
                      <InputField
                        isLabel={true}
                        lable="Technology Name"
                        value={this.state.techName}
                        onChange={(e) =>
                          this.setState({ techName: e.target.value })
                        }
                      />
                    </div>

                    <div>
                      <p style={{ fontSize: ".9rem" }}>Tech Logo</p>
                      {this.state.techLogo.url ? (
                        <div style={{ width: "100px" }}>
                          <div
                            style={{
                              width: "100%",
                              height: "100px",
                              borderRadius: "10px",
                              display: "flex",
                              border: "2px dashed var(--blue-dark)",
                              position: "relative",
                              marginTop: "10px",
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faClose}
                              style={{
                                position: "absolute",
                                top: "0",
                                right: "0",
                                background: "var(--blue-light)",
                                color: "var(--blue-dark)",
                                borderRadius: "100%",
                                transform: "translate(50%,-50%)",
                                height: "15px",
                                width: "15px",
                                padding: "5px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                this.setState({
                                  techLogo: { url: "", obj: "" },
                                });
                              }}
                            />
                            <img
                              src={this.state.techLogo.url}
                              style={{
                                width: "100%",
                                height: "100px",
                                objectFit: "contain",
                                borderRadius: "10px",
                              }}
                              alt=""
                            />
                          </div>
                          {this.state.techLogo?.obj && (
                            <p
                              style={{ textAlign: "center", fontSize: ".7rem" }}
                            >
                              {this.state.techLogo?.obj.name}
                            </p>
                          )}
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "100px",
                            height: "100px",
                            border: "2px dashed var(--blue-dark)",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                            position: "relative",
                          }}
                        >
                          <input
                            type="file"
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              right: 0,
                              left: 0,
                              opacity: 0,
                            }}
                            onChange={(e) => {
                              this.setState({
                                techLogo: {
                                  url: URL.createObjectURL(e.target.files[0]),
                                  obj: e.target.files[0],
                                },
                              });
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faPlus}
                            style={{ color: "var(--blue-dark)" }}
                          />
                        </div>
                      )}
                    </div>
                    {this.state.techLogo?.url && (
                      <div className="grid_2">
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Caption"}
                          value={this.state.techLogoCaption}
                          onChange={(e) => {
                            this.setState({ techLogoCaption: e.target.value });
                          }}
                        />
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Alt"}
                          value={this.state.techLogoAlt}
                          onChange={(e) =>
                            this.setState({ techLogoAlt: e.target.value })
                          }
                        />
                      </div>
                    )}
                    {this.state.fold1?.map((value, index) => {
                      return (
                        <div className="sub_card grid" key={index}>
                          <FontAwesomeIcon
                            icon={faClose}
                            className="sub_card_close"
                            onClick={() => {
                              let temp = this.state.fold1;
                              temp.splice(index, 1);
                              this.setState({ fold1: [...temp] });
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Title</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.fold1];
                                temp[index].title = val;
                                this.setState({ fold1: temp });
                              }}
                              content={value.title}
                              smallEditor={true}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Description</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.fold1];
                                temp[index].description = val;
                                this.setState({ fold1: temp });
                              }}
                              content={value.description}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              <div className="card grid">
                <h3>Case Study</h3>
                <div className="grid_2">
                  <InputField
                    type="select"
                    placeholder="Select Case Study"
                    value={this.state.selectedCaseStudy}
                    onChange={(e) =>
                      this.setState({ selectedCaseStudy: e.target.value })
                    }
                    options={this.state.caseStudies}
                    accessText="title"
                    accessValue="_id"
                  />
                </div>
              </div>

              <div className="card grid">
                <h3>
                  Why Section
                  <button
                    onClick={() => {
                      let temp = [...this.state.why];
                      temp.push({
                        title: "",
                        description: "",
                        icon: { url: "", obj: "" },
                        iconCaption: "",
                        iconAlt: "",
                      });
                      this.setState({ why: temp });
                    }}
                  >
                    Add
                  </button>
                </h3>
                {this.state.why.length !== 0 && (
                  <div className="grid">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <p style={{ paddingLeft: "5px" }}>Heading</p>
                      <TextEditor
                        handleChange={(val) => {
                          this.setState({ whyHeading: val });
                        }}
                        content={this.state.whyHeading}
                        smallEditor={true}
                      />
                    </div>
                    <div>
                      <p style={{ fontSize: ".9rem" }}>Image</p>
                      {this.state.whyImage.url ? (
                        <div style={{ width: "100px" }}>
                          <div
                            style={{
                              width: "100%",
                              height: "100px",
                              borderRadius: "10px",
                              display: "flex",
                              border: "2px dashed var(--blue-dark)",
                              position: "relative",
                              marginTop: "10px",
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faClose}
                              style={{
                                position: "absolute",
                                top: "0",
                                right: "0",
                                background: "var(--blue-light)",
                                color: "var(--blue-dark)",
                                borderRadius: "100%",
                                transform: "translate(50%,-50%)",
                                height: "15px",
                                width: "15px",
                                padding: "5px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                this.setState({
                                  whyImage: { url: "", obj: "" },
                                });
                              }}
                            />
                            <img
                              src={this.state.whyImage.url}
                              style={{
                                width: "100%",
                                height: "100px",
                                objectFit: "contain",
                                borderRadius: "10px",
                              }}
                              alt=""
                            />
                          </div>
                          {this.state.whyImage?.obj && (
                            <p
                              style={{ textAlign: "center", fontSize: ".7rem" }}
                            >
                              {this.state.whyImage?.obj.name}
                            </p>
                          )}
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "100px",
                            height: "100px",
                            border: "2px dashed var(--blue-dark)",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                            position: "relative",
                          }}
                        >
                          <input
                            type="file"
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              right: 0,
                              left: 0,
                              opacity: 0,
                            }}
                            onChange={this.handleWhyImage}
                          />
                          <FontAwesomeIcon
                            icon={faPlus}
                            style={{ color: "var(--blue-dark)" }}
                          />
                        </div>
                      )}
                    </div>
                    <div className="grid_2">
                      <div
                        style={{
                          height: "50px",
                          width: "100%",
                          border: "1px solid lightgrey",
                          background: "white",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          paddingInline: "15px",
                          justifyContent: "space-between",
                          marginTop: "25px",
                        }}
                      >
                        <p>Show Button</p>
                        <ToggleSwitch
                          value={this.state.whyShowButton}
                          onClick={() =>
                            this.setState({
                              whyShowButton: !this.state.whyShowButton,
                            })
                          }
                        />
                      </div>
                      {this.state.showBtn && (
                        <>
                          <InputField
                            type="text"
                            isLabel={true}
                            value={this.state.whyButtonText}
                            lable="Button Text"
                            placeholder="Enter button text"
                            onChange={(e) => {
                              this.setState({ whyButtonText: e.target.value });
                            }}
                          />
                          <InputField
                            type="text"
                            isLabel={true}
                            value={this.state.whyButtonLink}
                            lable="Button Link"
                            placeholder="Enter button Link"
                            onChange={(e) => {
                              this.setState({ whyButtonLink: e.target.value });
                            }}
                          />
                        </>
                      )}
                    </div>
                    {this.state.whyImage?.url && (
                      <div className="grid_2">
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Caption"}
                          value={this.state.whyImageCaption}
                          onChange={(e) => {
                            this.setState({ whyImageCaption: e.target.value });
                          }}
                        />
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Alt"}
                          value={this.state.whyImageAlt}
                          onChange={(e) =>
                            this.setState({ whyImageAlt: e.target.value })
                          }
                        />
                      </div>
                    )}
                    {this.state.why.map((value, index) => {
                      return (
                        <div className="sub_card grid" key={index}>
                          <FontAwesomeIcon
                            icon={faClose}
                            className="sub_card_close"
                            onClick={() => {
                              let temp = this.state.why;
                              temp.splice(index, 1);
                              this.setState({ why: [...temp] });
                            }}
                          />
                          <div>
                            <p style={{ fontSize: ".9rem" }}>Icon</p>
                            {value.icon.url ? (
                              <div style={{ width: "70px" }}>
                                <div
                                  style={{
                                    width: "100%",
                                    height: "70px",

                                    background: "var(--blue-light)",
                                    borderRadius: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginTop: "5px",
                                    position: "relative",
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={faClose}
                                    style={{
                                      color: "var(--blue-dark)",
                                      cursor: "pointer",
                                      height: "15px",
                                      width: "15px",
                                      padding: "5px",
                                      position: "absolute",
                                      top: 0,
                                      right: 0,
                                      transform: "translate(50%, -50%)",
                                    }}
                                    onClick={() => {
                                      let temp = [...this.state.why];
                                      temp[index].icon = { url: "", obj: "" };
                                      this.setState({ why: temp });
                                    }}
                                  />
                                  <img
                                    src={value.icon.url}
                                    alt=""
                                    style={{
                                      height: "100%",
                                      width: "100%",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                                {value.icon?.obj && (
                                  <p
                                    style={{
                                      fontSize: ".6rem",
                                      textAlign: "center",
                                    }}
                                  >
                                    {value.icon?.obj.name}
                                  </p>
                                )}
                              </div>
                            ) : (
                              <div
                                style={{
                                  width: "70px",
                                  height: "70px",
                                  position: "relative",
                                  background: "var(--blue-light)",
                                  borderRadius: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginTop: "5px",
                                }}
                              >
                                <input
                                  type="file"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    opacity: 0,
                                  }}
                                  accept="image/*"
                                  onChange={(e) => {
                                    let temp = [...this.state.why];
                                    temp[index].icon = {
                                      url: URL.createObjectURL(
                                        e.target.files[0]
                                      ),
                                      obj: e.target.files[0],
                                    };
                                    this.setState({ why: temp });
                                  }}
                                />
                                <FontAwesomeIcon
                                  icon={faPlus}
                                  style={{ color: "var(--blue-dark)" }}
                                />
                              </div>
                            )}
                          </div>
                          {value.icon?.url && (
                            <div className="grid_2">
                              <InputField
                                type="text"
                                isLabel={true}
                                lable={"Image Caption"}
                                value={value.iconCaption}
                                onChange={(e) => {
                                  let temp = [...this.state.why];
                                  temp[index].iconCaption = e.target.value;
                                  this.setState({ why: temp });
                                }}
                              />
                              <InputField
                                type="text"
                                isLabel={true}
                                lable={"Image Alt"}
                                value={value.iconAlt}
                                onChange={(e) => {
                                  let temp = [...this.state.why];
                                  temp[index].iconAlt = e.target.value;
                                  this.setState({ why: temp });
                                }}
                              />
                            </div>
                          )}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Title</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.why];
                                temp[index].title = val;
                                this.setState({ why: temp });
                              }}
                              content={value?.title}
                              smallEditor={true}
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Description</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.why];
                                temp[index].description = val;
                                this.setState({ why: temp });
                              }}
                              content={value.description}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <div className="card grid">
                <h3>
                  Key Points
                  <button
                    onClick={() => {
                      let temp = [...this.state.keyPoints];
                      temp.push({
                        title: "",
                        description: "",
                        points: [],
                        pointText: "",
                      });
                      this.setState({ keyPoints: temp });
                    }}
                  >
                    Add
                  </button>
                </h3>
                {this.state.keyPoints.length !== 0 && (
                  <div className="grid">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <p style={{ paddingLeft: "5px" }}>Heading</p>
                      <TextEditor
                        handleChange={(val) => {
                          this.setState({ keyPointsHeading: val });
                        }}
                        content={this.state.keyPointsHeading}
                        smallEditor={true}
                      />
                    </div>
                    {this.state.keyPoints.map((value, index) => {
                      return (
                        <div className="sub_card grid" key={index}>
                          <FontAwesomeIcon
                            icon={faClose}
                            className="sub_card_close"
                            onClick={() => {
                              let temp = this.state.keyPoints;
                              temp.splice(index, 1);
                              this.setState({ keyPoints: [...temp] });
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Title</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.keyPoints];
                                temp[index].title = val;
                                this.setState({ keyPoints: temp });
                              }}
                              content={value.title}
                              smallEditor={true}
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Description</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.keyPoints];
                                temp[index].description = val;
                                this.setState({ keyPoints: temp });
                              }}
                              content={value.description}
                            />
                          </div>

                          <div>
                            <InputField
                              type="text"
                              isLabel={true}
                              lable="Points (Press Enter to add value)"
                              value={value.pointText}
                              onChange={(e) => {
                                let temp = [...this.state.keyPoints];
                                temp[index].pointText = e.target.value;
                                this.setState({ keyPoints: temp });
                              }}
                              onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                  let temp = [...this.state.keyPoints];
                                  temp[index].points.push(value.pointText);
                                  temp[index].pointText = "";
                                  this.setState({ keyPoints: temp });
                                }
                              }}
                            />
                            <div
                              style={{
                                display: "flex",
                                marginTop: "10px",
                                gap: "10px",
                              }}
                            >
                              {value.points?.map((v, i) => {
                                return (
                                  <div
                                    key={i}
                                    style={{
                                      background: "var(--blue-light)",
                                      color: "var(--blue-dark)",
                                      padding: "5px 10px",
                                      borderRadius: "5px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <p style={{ color: "var(--blue-dark)" }}>
                                      {v}
                                    </p>
                                    <FontAwesomeIcon
                                      icon={faClose}
                                      style={{
                                        color: "var(--blue-dark)",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        let temp = [...this.state.keyPoints];
                                        temp[index].points.splice(i, 1);
                                        this.setState({ keyPoints: temp });
                                      }}
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <div className="card grid">
                <h3>
                  Tailored Section
                  <button
                    onClick={() => {
                      let temp = [...this.state.tailored];
                      temp.push({
                        title: "",
                        secondaryTitle: "",
                        description: "",
                        icon: { url: "", obj: "" },
                        iconCaption: "",
                        iconAlt: "",
                      });
                      this.setState({ tailored: temp });
                    }}
                  >
                    Add
                  </button>
                </h3>
                {this.state.tailored.length !== 0 && (
                  <div className="grid">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <p style={{ paddingLeft: "5px" }}>Heading</p>
                      <TextEditor
                        handleChange={(val) => {
                          this.setState({
                            tailoredHeading: val,
                          });
                        }}
                        content={this.state.tailoredHeading}
                        smallEditor={true}
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <p style={{ paddingLeft: "5px" }}>Description</p>
                      <TextEditor
                        handleChange={(val) => {
                          this.setState({
                            tailoredDescription: val,
                          });
                        }}
                        content={this.state.tailoredDescription}
                        smallEditor={true}
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <p style={{ paddingLeft: "5px" }}>Second Heading</p>
                      <TextEditor
                        handleChange={(val) => {
                          this.setState({
                            tailoredSecondHeading: val,
                          });
                        }}
                        content={this.state.tailoredSecondHeading}
                        smallEditor={true}
                      />
                    </div>
                    <div className="grid_2">
                      <div
                        style={{
                          height: "50px",
                          width: "100%",
                          border: "1px solid lightgrey",
                          background: "white",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          paddingInline: "15px",
                          justifyContent: "space-between",
                          marginTop: "25px",
                        }}
                      >
                        <p>Show Button</p>
                        <ToggleSwitch
                          value={this.state.tailoredBtnShow}
                          onClick={() =>
                            this.setState({
                              tailoredBtnShow: !this.state.tailoredBtnShow,
                            })
                          }
                        />
                      </div>

                      {this.state.tailoredBtnShow && (
                        <>
                          <InputField
                            type="text"
                            isLabel={true}
                            lable={"Button Text"}
                            value={this.state.tailoredBtnText}
                            onChange={(e) =>
                              this.setState({ tailoredBtnText: e.target.value })
                            }
                          />
                          <InputField
                            type="text"
                            isLabel={true}
                            lable={"Button Url"}
                            value={this.state.tailoredBtnUrl}
                            onChange={(e) =>
                              this.setState({ tailoredBtnUrl: e.target.value })
                            }
                          />
                        </>
                      )}
                    </div>

                    {this.state.tailored.map((value, index) => {
                      return (
                        <div className="sub_card grid" key={index}>
                          <h3>Step {index + 1}</h3>
                          <div>
                            <p style={{ fontSize: ".9rem" }}>Icon</p>
                            {value.icon.url ? (
                              <div style={{ width: "70px" }}>
                                <div
                                  style={{
                                    width: "100%",
                                    height: "70px",

                                    background: "var(--blue-light)",
                                    borderRadius: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginTop: "5px",
                                    position: "relative",
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={faClose}
                                    style={{
                                      height: "15px",
                                      width: "15px",
                                      padding: "5px",
                                      color: "var(--blue-dark)",
                                      display: "var(--blue-light)",
                                      position: "absolute",
                                      top: 0,
                                      right: 0,
                                      transform: "translate(50%, -50%)",
                                    }}
                                    onClick={() => {
                                      let temp = [...this.state.tailored];
                                      temp[index].icon = { url: "", obj: "" };
                                      this.setState({ tailored: temp });
                                    }}
                                  />
                                  <img
                                    src={value.icon.url}
                                    alt=""
                                    style={{
                                      objectFit: "contain",
                                      height: "100%",
                                      width: "100%",
                                      borderRadius: "10px",
                                    }}
                                  />
                                </div>
                                {value.icon?.obj && (
                                  <p
                                    style={{
                                      fontSize: ".6rem",
                                      textAlign: "center",
                                    }}
                                  >
                                    {value.icon?.obj.name}
                                  </p>
                                )}
                              </div>
                            ) : (
                              <div
                                style={{
                                  width: "70px",
                                  height: "70px",

                                  background: "var(--blue-light)",
                                  borderRadius: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginTop: "5px",
                                  position: "relative",
                                }}
                              >
                                <input
                                  type="file"
                                  accept="image/*"
                                  style={{
                                    top: 0,
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    opacity: 0,
                                    cursor: "pointer",
                                    position: "absolute",
                                  }}
                                  onChange={(e) => {
                                    let temp = [...this.state.tailored];
                                    temp[index].icon = {
                                      url: URL.createObjectURL(
                                        e.target.files[0]
                                      ),
                                      obj: e.target.files[0],
                                    };
                                    this.setState({ tailored: temp });
                                  }}
                                />
                                <FontAwesomeIcon
                                  icon={faPlus}
                                  style={{ color: "var(--blue-dark)" }}
                                />
                              </div>
                            )}
                          </div>
                          {value.icon?.url && (
                            <div className="grid_2">
                              <InputField
                                type="text"
                                isLabel={true}
                                lable={"Image Caption"}
                                value={value.iconCaption}
                                onChange={(e) => {
                                  let temp = [...this.state.tailored];
                                  temp[index].iconCaption = e.target.value;
                                  this.setState({ tailored: temp });
                                }}
                              />
                              <InputField
                                type="text"
                                isLabel={true}
                                lable={"Image Alt"}
                                value={value.iconAlt}
                                onChange={(e) => {
                                  let temp = [...this.state.tailored];
                                  temp[index].iconAlt = e.target.value;
                                  this.setState({ tailored: temp });
                                }}
                              />
                            </div>
                          )}
                          <FontAwesomeIcon
                            icon={faClose}
                            className="sub_card_close"
                            onClick={() => {
                              let temp = this.state.tailored;
                              temp.splice(index, 1);
                              this.setState({ tailored: [...temp] });
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Title</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.tailored];
                                temp[index].title = val;
                                this.setState({ tailored: temp });
                              }}
                              content={value.title}
                              smallEditor={true}
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>
                              Secondary Title
                            </p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.tailored];
                                temp[index].secondaryTitle = val;
                                this.setState({ tailored: temp });
                              }}
                              content={value.secondaryTitle}
                              smallEditor={true}
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Description</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.tailored];
                                temp[index].description = val;
                                this.setState({ tailored: temp });
                              }}
                              content={value.description}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <div className="card grid">
                <h3>
                  F & Q
                  <button
                    onClick={() => {
                      let temp = [...this.state.qanda];
                      temp.push({
                        question: "",
                        answer: "",
                      });
                      this.setState({ qanda: temp });
                    }}
                  >
                    Add
                  </button>
                </h3>
                {this.state.qanda.length !== 0 && (
                  <div className="grid">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <p style={{ paddingLeft: "5px" }}>Heading</p>
                      <TextEditor
                        handleChange={(val) => {
                          this.setState({ qandaHeading: val });
                        }}
                        content={this.state.qandaHeading}
                        smallEditor={true}
                      />
                    </div>
                    {this.state.qanda.map((value, index) => {
                      return (
                        <div className="sub_card grid" key={index}>
                          <FontAwesomeIcon
                            icon={faClose}
                            className="sub_card_close"
                            onClick={() => {
                              let temp = this.state.qanda;
                              temp.splice(index, 1);
                              this.setState({ qanda: [...temp] });
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Question</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.qanda];
                                temp[index].question = val;
                                this.setState({ qanda: temp });
                              }}
                              content={value.question}
                              smallEditor={true}
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Answer</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.qanda];
                                temp[index].answer = val;
                                this.setState({ qanda: temp });
                              }}
                              content={value.answer}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              <div className="card grid">
                <h3>Meta Data</h3>
                <InputField
                  isLabel={true}
                  lable="Slug"
                  type="text"
                  value={this.state.slug}
                  onChange={(e) =>
                    this.setState({ slug: e.target.value.replace(" ", "-") })
                  }
                />
                <InputField
                  isLabel={true}
                  lable="Meta Title"
                  type="text"
                  value={this.state.metaTitle}
                  onChange={(e) => this.setState({ metaTitle: e.target.value })}
                />
                <InputField
                  isLabel={true}
                  lable="Meta Description"
                  type="textarea"
                  value={this.state.metaDescription}
                  onChange={(e) =>
                    this.setState({ metaDescription: e.target.value })
                  }
                />
                <InputField
                  isLabel={true}
                  lable="Canonical Url"
                  type="textarea"
                  value={this.state.metaCanonicalUrl}
                  onChange={(e) =>
                    this.setState({ metaCanonicalUrl: e.target.value })
                  }
                />
              </div>
            </div>
          </ContentBody>
        </Content>
      </>
    );
  }
}

export default withRouter(AddUpdateTechnology);
